import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { comics } from "@/mocks/comics";

type RankTab = "hot" | "follow" | "update";

const tabs: { key: RankTab; label: string }[] = [
  { key: "hot", label: "人气榜" },
  { key: "follow", label: "收藏榜" },
  { key: "update", label: "更新榜" },
];

export default function Rank() {
  const [tab, setTab] = useState<RankTab>("hot");

  const list =
    tab === "hot"
      ? [...comics].sort((a, b) => Number(a.views.replace("万", "").replace("亿", "")) - Number(b.views.replace("万", "").replace("亿", ""))).reverse()
      : tab === "follow"
        ? [...comics].sort((a, b) => b.follows - a.follows)
        : [...comics].reverse();

  return (
    <Layout>
      <div className="mx-auto max-w-5xl px-4 py-8 md:px-6">
        <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1 text-sm text-foreground-500">
          <a href="/" className="hover:text-primary-600">首页</a>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-700">排行榜</span>
        </nav>

        <header className="mt-4">
          <h1 className="font-heading text-3xl text-foreground-950 md:text-4xl">漫画排行榜</h1>
          <p className="mt-2 text-sm text-foreground-600">数据实时更新,看看大家都在追什么</p>
        </header>

        {/* Tabs */}
        <div className="mt-6 inline-flex rounded-full bg-secondary-100 p-1 dark:bg-secondary-100/70">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`rounded-full px-6 py-2 text-sm whitespace-nowrap transition-colors ${
                tab === t.key ? "bg-primary-600 text-background-50" : "text-secondary-900 hover:text-foreground-950"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* List */}
        <div className="mt-6 flex flex-col gap-3">
          {list.map((comic, i) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 rounded-xl border border-background-200/80 bg-background-50 p-3 transition-transform hover:-translate-y-0.5"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-heading text-xl ${
                  i === 0
                    ? "bg-accent-500 text-background-50"
                    : i === 1
                      ? "bg-primary-600 text-background-50"
                      : i === 2
                        ? "bg-secondary-400 text-background-50"
                        : "bg-secondary-100 text-secondary-900"
                }`}
              >
                {i + 1}
              </span>
              <img
                src={comic.cover}
                alt={`${comic.title}封面`}
                className="h-16 w-12 shrink-0 rounded-md object-cover object-top"
              />
              <div className="min-w-0 flex-1">
                <p className="truncate text-base font-bold text-foreground-950">{comic.title}</p>
                <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                  <span>{comic.category}</span>
                  <span>{comic.status}</span>
                  <span>{comic.author}</span>
                </p>
                <p className="mt-1 truncate text-xs text-foreground-400">更新:{comic.chapters[comic.chapters.length - 1]}</p>
              </div>
              <div className="flex shrink-0 flex-col items-end gap-1">
                <span className="flex items-center gap-1 text-sm font-bold text-accent-600">
                  <i className="ri-star-fill"></i>
                  {comic.rating.toFixed(1)}
                </span>
                <span className="text-xs text-foreground-500">
                  {tab === "follow" ? `${(comic.follows / 10000).toFixed(1)}万人收藏` : `人气 ${comic.views}`}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* ItemList schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "策驰漫画网排行榜",
            itemListElement: list.map((c, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: c.title,
              url: `https://faequest.github.io/comic/${c.id}`,
            })),
          }),
        }}
      />
    </Layout>
  );
}